import * as React from "react";

const ChevronDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    fill="none"
    viewBox="0 0 28 28"
  >
    <path
      stroke="#068EC3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
      d="m21 10.5-7 7-7-7"
    ></path>
  </svg>
);

export const ChevronDown2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
  >
    <path
      stroke="#62748E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M13.5 6.75 9 11.25l-4.5-4.5"
    ></path>
  </svg>
);

export default ChevronDown;

